// @flow
import React from 'react';
import PropTypes from 'prop-types';
import I18n from '../../../i18n/I18n';
import Helper from '../../../helper/Helper';
import styles from './OrderCard.scss';

const OrderCard = (props: Object) => {
  const data = props.data || '';
  return (
    <div className={styles.ctr}>
      <div className={styles.cardTitle}>
        {props.day || ''}
      </div>
      <div className={styles.totalWrapper}>
        <div className={styles.indWrapper}>
          <div className={styles.indTitle}>
            {I18n.getText('summary.total-orders', {}, 'Total Orders')}
          </div>
          {data && data.total_orders
            ? <div className={styles.content}>
                {data.total_orders}
              </div>
            : ''}
        </div>
        {false && <div className={styles.indWrapper}>
          <div className={styles.indTitle}>
            {I18n.getText('summary.revenue', {}, 'Revenue')}
          </div>
          {data && data.revenue
            ? <div className={styles.content}>
                {I18n.formatCurrency(Helper.formatPrice(data.revenue, props.currencyCode))}
              </div>
            : ''}
        </div>}

        {false && <div className={styles.indWrapper}>
          <div className={styles.indTitle}>
            {I18n.getText('summary.avg', {}, 'Average')}
          </div>
          {data && data.average
            ? <div className={styles.content}>
                {data.average}
              </div>
            : ''}
        </div>}

        <div className={styles.indWrapper}>
          <div className={styles.indTitle}>
            {I18n.getText('summary.total', {}, 'Total Amount')}
          </div>
          {data && data.total
            ? <div className={styles.content}>
                {I18n.formatCurrency(Helper.formatPrice(data.total, props.currencyCode))}
              </div>
            : ''}
        </div>
      </div>
    </div>
  );
};

OrderCard.propTypes = {};

OrderCard.getDefaultProps = {};

export default OrderCard;



// WEBPACK FOOTER //
// ./src/components/dashboard/orderCard/OrderCard.js